import React, {Component} from 'react';
import {formatTime} from "../../../utils";
class TaskTime extends Component {
    render() {
        let {text} = this.props;
        return  <div style={{display:"flex",overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap",alignItems:"center"}}>
             <div>{formatTime(text)}</div>
        </div>
    }
}

export default TaskTime;
